"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformUserBirthdayToDate = transformUserBirthdayToDate;
const legacy_config_1 = require("@daytrip/legacy-config");
function transformUserBirthdayToDate(birthdayAt) {
    return birthdayAt ?? new Date(legacy_config_1.DEFAULT_BIRTHDAY_AT);
}
//# sourceMappingURL=transformUserBirthdayToDate.js.map